import { Config } from "@bugsnag/js"
import { publicEnvVars } from "../config"
import packageFile from "../../../package.json"

export const bugsnagConfig: Config = {
    appVersion: packageFile.version,
    apiKey: publicEnvVars.BUGSNAG_API_KEY,
    releaseStage: publicEnvVars.ENVIRONMENT,
    enabledReleaseStages: ["production", "development"],
}
